// src/components/card/SecurityRoom.tsx

import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  List,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { FolderId, SensorId, SensorRecord, SensorType } from '@/types/domain'

import { IntervalAlert, SecurityRoomSensor } from '..'
import { getStatusColor, SVGStatus } from '../../api'
import { useSecuritySensors } from '../../hooks'

type SecurityRoomProps = {
  id: FolderId
  type: SensorType
}

export const SecurityRoom = ({ id, type }: SecurityRoomProps) => {
  const navigate = useNavigate()

  const sSensors: SensorRecord[] = useSecuritySensors(id)
  const roomSensors: SensorRecord[] = sSensors
    .filter(f => f.name === type)
    .sort()
  const status = getStatusColor(roomSensors)

  const avatar = (
    <Avatar>
      <SVGStatus type={'security'} status={status} />
    </Avatar>
  )

  return (
    <Card variant={'security'}>
      <CardHeader
        avatar={avatar}
        slotProps={{ title: { variant: 'h6' } }}
        title={type}
        variant={'security'}
      />

      <CardContent sx={{ p: '0 !important' }}>
        <Collapse in={true}>
          {/* display interval alert, if applicable  */}
          <IntervalAlert title={type} sensors={sSensors} />

          <List>
            {roomSensors.map(item => {
              const { entity_id } = item
              const sId: SensorId = Number(entity_id)
              const pathname: string = `/folder/${id}/home/correlation`
              const onClick = () =>
                navigate(pathname, { state: { sensorId: sId } })

              return (
                <SecurityRoomSensor
                  id={id}
                  key={sId}
                  onClick={onClick}
                  sensorId={sId}
                />
              )
            })}
          </List>
        </Collapse>
      </CardContent>
    </Card>
  )
}
